import axiosConfig from '../../../../../../redux/Spoolsbase/axiosConfig';
import type { FatSpecificationTemplateDto } from './fatSpecificationTemplateTypes';

const BASE = '/fat-specification-templates';

function unwrapData<T>(res: { data?: unknown }): T {
  const root = res?.data as { data?: T } | undefined;
  if (root && typeof root === 'object' && 'data' in root && root.data !== undefined) {
    return root.data as T;
  }
  return root as T;
}

export async function listFatSpecificationTemplates(params: {
  projectId: string | number;
  pipeId?: string | number;
  spoolIndex?: string | number;
}): Promise<{
  projectId: number;
  pipeId: number | null;
  templates: FatSpecificationTemplateDto[];
}> {
  const { data } = await axiosConfig.get(BASE, {
    params: {
      project_id: params.projectId,
      ...(params.pipeId != null && params.pipeId !== '' ? { pipe_id: params.pipeId } : {}),
      ...(params.spoolIndex != null && params.spoolIndex !== '' ? { spool_index: params.spoolIndex } : {}),
    },
  });
  const payload = unwrapData<
    | FatSpecificationTemplateDto[]
    | FatSpecificationTemplateDto
    | {
        projectId?: number;
        pipeId?: number | null;
        templates?: FatSpecificationTemplateDto[];
      }
  >(data);
  if (Array.isArray(payload)) {
    return {
      projectId: Number(params.projectId),
      pipeId: params.pipeId != null && params.pipeId !== '' ? Number(params.pipeId) : null,
      templates: payload,
    };
  }
  if ('id' in payload && 'payload' in payload) {
    return {
      projectId: payload.projectId ?? Number(params.projectId),
      pipeId: payload.pipeId ?? (params.pipeId != null && params.pipeId !== '' ? Number(params.pipeId) : null),
      templates: [payload],
    };
  }
  return {
    projectId: payload?.projectId ?? Number(params.projectId),
    pipeId: payload?.pipeId ?? (params.pipeId != null && params.pipeId !== '' ? Number(params.pipeId) : null),
    templates: Array.isArray(payload?.templates) ? payload.templates : [],
  };
}

export async function saveFatSpecificationTemplate(body: {
  id?: number;
  projectId: number;
  pipeId: number;
  spoolIndex: number;
  category?: string;
  reference?: string | null;
  payload: object | null;
}): Promise<FatSpecificationTemplateDto> {
  const { data } = await axiosConfig.post(BASE, {
    projectId: body.projectId,
    pipeId: body.pipeId,
    spoolIndex: body.spoolIndex,
    ...(body.id != null ? { id: body.id } : {}),
    category: body.category,
    reference: body.reference,
    payload: body.payload,
  });
  return unwrapData(data);
}
